module.exports = __webpack_public_path__ + "img/mbl.84a3033d.jpg";